import type {ProjetType} from "./../types/projet.type";

export const ProjetMockStripe: ProjetType[] = [];
